/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FCWithChildren } from '@pbk-web/types';

export type SlotType<T> = FCWithChildren<{ name: T }>;

const Slot: SlotType<any> = () => null;

const withSlot = <TProps, TSlots>(component: FCWithChildren<TProps & { _slots: TSlots }>): FCWithChildren<TProps> & { Slot: SlotType<TSlots> } => {
  const c = component as FCWithChildren<TProps> & { Slot: SlotType<TSlots> };
  c.Slot = Slot;

  return c;
};

export type SlotDefinitions<T extends any[]> = T[number];

export default withSlot;
